import { Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { formatDateWithWeekday } from "@outschool/time";
import React from "react";

import useSectionString from "../../../shared/hooks/useSectionString";
import { useTimeZone } from "../../providers/TimeZoneProvider";

export default function WaitlistSectionSummaryString({
  activity,
  section,
}: {
  activity: any;
  section: any;
}) {
  const { t } = useTranslation(
    "client\\components\\waitlists\\SectionWaitlistForm",
  );
  const { timeZone } = useTimeZone();
  const { fullDurationStringFromGql, fullDurationString } = useSectionString();
  const { nextOngoingMeeting } = section;

  const divider = <Typography sx={{ color: "grey.300" }}> • </Typography>;
  let sectionString: React.ReactNode = null,
    meetingString: React.ReactNode = null;
  if (
    nextOngoingMeeting ||
    (activity.duration_weeks && activity.duration_weeks > 1)
  ) {
    // Ongoing / fixed-duration
    sectionString = fullDurationStringFromGql({
      activity,
      section,
      nextOngoingMeeting,
      userTimeZone: timeZone,
      showTz: false,
    });
    meetingString = t("First meeting: {{firstMeetingDate}}", {
      firstMeetingDate: formatDateWithWeekday(
        nextOngoingMeeting?.start_time ?? section?.start_time,
        timeZone,
      ),
    });
  } else {
    // One-time / Camp / Flex
    sectionString = fullDurationString({
      activity,
      section,
      nextOngoingMeeting,
      userTimeZone: timeZone,
      showTz: false,
    });
  }

  return (
    <>
      <Typography sx={{ fontWeight: 500 }}>{sectionString}</Typography>
      {meetingString && divider}
      {meetingString}
    </>
  );
}
